import React from 'react'
import { AttachmentEntry } from './AttachmentsStep'

const URGENCY_BADGE: Record<string, { label: string; color: string; background: string; border: string }> = {
  emergency: { label: 'Emergency', color: '#E53935', background: '#FFEBEE', border: '1px solid #FFCDD2' },
  high:      { label: 'High',      color: '#E65100', background: '#FFF3E0', border: '1px solid #FFE0B2' },
  medium:    { label: 'Medium',    color: '#1565C0', background: '#E3F2FD', border: '1px solid #BBDEFB' },
  low:       { label: 'Low',       color: '#2E7D32', background: '#E8F5E9', border: '1px solid #C8E6C9' },
}

const LABEL_STYLE: React.CSSProperties = {
  fontSize: '0.875rem',
  color: '#9ca3af',
  width: '160px',
  flexShrink: 0,
}

const VALUE_STYLE: React.CSSProperties = {
  fontSize: '0.875rem',
  color: '#111827',
}

interface ReviewStepProps {
  issueType: string
  reportType: string
  location: string
  urgency: string
  affectsNeighbours: string
  description: string
  attachments: AttachmentEntry[]
}

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

const ReviewRow = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <div style={{ display: 'flex', alignItems: 'center', padding: '14px 20px', borderBottom: '1px solid #f3f4f6' }}>
    <span style={LABEL_STYLE}>{label}</span>
    <span style={VALUE_STYLE}>{children}</span>
  </div>
)

const ReviewStep = ({ issueType, reportType, location, urgency, affectsNeighbours, description, attachments }: ReviewStepProps) => {
  const badge = URGENCY_BADGE[urgency]

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <div>
        <h3 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#0a0d47', margin: '0 0 4px' }}>Review and submit</h3>
        <p style={{ fontSize: '0.875rem', color: '#9ca3af', margin: 0 }}>Please review the information below before submitting your request.</p>
      </div>

      <div style={{ border: '1px solid #e5e7eb', borderRadius: '12px', overflow: 'hidden' }}>
        <ReviewRow label="Issue type">{capitalize(issueType) || '—'}</ReviewRow>
        <ReviewRow label="Report type">{reportType === 'damage' ? 'Damage Report' : 'General Inquiry'}</ReviewRow>
        <ReviewRow label="Location">{capitalize(location) || '—'}</ReviewRow>
        <ReviewRow label="Urgency">
          {badge ? (
            <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: '4px', fontSize: '0.8125rem', fontWeight: 600, color: badge.color, background: badge.background, border: badge.border }}>
              {badge.label}
            </span>
          ) : '—'}
        </ReviewRow>
        <ReviewRow label="Affects neighbours">{affectsNeighbours === 'yes' ? 'Yes' : affectsNeighbours === 'no' ? 'No' : '—'}</ReviewRow>
        <ReviewRow label="Description">{description.trim() || 'None'}</ReviewRow>
        <div style={{ display: 'flex', alignItems: 'center', padding: '14px 20px' }}>
          <span style={LABEL_STYLE}>Attachments</span>
          <span style={VALUE_STYLE}>{attachments.length > 0 ? `${attachments.length} file${attachments.length > 1 ? 's' : ''}` : 'None'}</span>
        </div>
      </div>
    </div>
  )
}

export default ReviewStep
